<div class="rounded-md bg-white divide-y">
    <div class="p-8">
        <div class="text-2xl font-medium">
            <ng-content select="[title]" />
        </div>
    </div>
    <div class="p-8 min-h-96">
        <ng-content select="[body]" />
    </div>
    <div class="bg-gray-100 w-full px-6 py-4">
        <div class="grid grid-cols-5 gap-2">
            <div class="col-span-1">
                <button app-button (click)="close()" size="lg" variant="flush" class="w-full justify-center">
                    Cancel
                </button>
            </div>
            <div class="col-span-4">
                <button app-button (click)="submit()" size="lg" class="w-full justify-center">
                    <ng-content select="[button-submit]" />
                </button>
            </div>
        </div>
    </div>
</div>
